import type { CSSProperties } from 'react';

import type { DataExplorerFilterBarProps } from './types';
import { cn } from './utils';

function toCssSize(value: number | string): string {
  return typeof value === 'number' ? `${value}px` : value;
}

export function DataExplorerFilterBar({
  label,
  leading,
  children,
  actions,
  maxFieldsHeight = 80,
  className,
  classNames,
  style,
  ...props
}: DataExplorerFilterBarProps) {
  const fieldsViewportStyle: CSSProperties = {
    maxHeight: toCssSize(maxFieldsHeight),
  };

  return (
    <div
      className={cn(
        'border-b border-border/60 bg-background px-8 py-3',
        classNames?.root,
        className,
      )}
      style={style}
      {...props}
    >
      <div
        className={cn(
          'flex min-w-0 items-start gap-2 text-sm',
          classNames?.layout,
        )}
      >
        {label ? (
          <div
            className={cn(
              'flex h-9 shrink-0 items-center font-semibold text-foreground',
              classNames?.label,
            )}
          >
            {label}
          </div>
        ) : null}

        <div
          className={cn(
            'min-w-0 flex-1 overflow-y-auto overscroll-contain',
            classNames?.fieldsViewport,
          )}
          style={fieldsViewportStyle}
        >
          <div
            className={cn(
              'flex flex-wrap items-center gap-2',
              classNames?.fields,
            )}
          >
            {leading}
            {children}
          </div>
        </div>

        {actions ? (
          <div
            className={cn(
              'flex shrink-0 items-center gap-2',
              classNames?.actions,
            )}
          >
            {actions}
          </div>
        ) : null}
      </div>
    </div>
  );
}
